import ArticleRankingSlider from './ArticleRankingSlider';
import ArticleSimpleSlider from './ArticleSimpleSlider';
import ArticleSlider from './ArticleSlider';
import FeaturedSlider from './FeaturedSlider';
import LatestArticles from './LatestArticles';
import NewspaperCategorySlider from './NewspaperCategorySlider';
import NewspaperStatic from './NewspaperStatic';
import NewspaperUnique from './NewspaperUnique';

function getArticleCollectionProps(collection) {
  return {
    key: collection.collection_id,
    cta: collection.cta_text,
    articles: collection.collection_articles,
    category: collection.collection_name,
    link: `/newspaper/${collection.collection_url}`,
    creator_name: collection.creator_name,
    creator_img: collection.creator_img,
    creator_username: collection.creator_username,
  };
}

function renderArticleSlider(collection) {
  return (
    <ArticleSlider
      key={collection.collection_id}
      articles={collection.collection_articles}
      category={collection.collection_name}
      link={`/newspaper/${collection.collection_url}`}
      image={collection.cover_image}
      creator_name={collection.creator_name}
      creator_img={collection.creator_img}
      creator_username={collection.creator_username}
      cssVariant={collection.carouselOptions?.type}
      settings={{
        slidesToShow: collection.carouselOptions?.slidesToShow,
        slidesToShowMobile: collection.carouselOptions?.slidesToShowMobile,
        autoplay: collection.carouselOptions?.autoplay,
        speed: collection.carouselOptions?.speed,
        gutter: collection.carouselOptions?.gutter,
      }}
    />
  );
}

const collectionSectionRenderers = {
  'newspaper-latest': collection => (
    <LatestArticles {...getArticleCollectionProps(collection)} />
  ),
  'newspaper-static': collection => (
    <NewspaperStatic {...getArticleCollectionProps(collection)} />
  ),
  'newspaper-unique': collection => (
    <NewspaperUnique {...getArticleCollectionProps(collection)} />
  ),
  'newspaper-featured': collection => (
    <FeaturedSlider {...getArticleCollectionProps(collection)} />
  ),
  'newspaper-ranking': collection => (
    <ArticleRankingSlider
      key={collection.collection_id}
      articles={collection.collection_articles}
      rankingPeriod={collection.ranking_period}
      category={collection.collection_name}
      link={`/newspaper/${collection.collection_url}`}
      backgroundImage={collection.background_image}
      creator_name={collection.creator_name}
      creator_img={collection.creator_img}
      creator_username={collection.creator_username}
    />
  ),
  'newspaper-categories': collection => (
    <NewspaperCategorySlider
      key={collection.collection_id}
      categories={collection.collection_internalcols}
    />
  ),
  'newspaper-simple': collection => (
    <ArticleSimpleSlider
      {...getArticleCollectionProps(collection)}
      backgroundImage={collection.background_image}
    />
  ),
};

export default function renderCollectionSection(collection) {
  const renderSection = collectionSectionRenderers[collection.type] || renderArticleSlider;
  return renderSection(collection);
}
